// Player names without typing. A guest is given a generated name ("Sneaky Otter") and can roll another; a logged-in
// CrazyGames player is shown by their CrazyGames username. No player-typed text ever reaches other players, so there
// is no user-generated content to moderate (CrazyGames multiplayer requirements: UGC needs moderation).
const ADJ = ["Sneaky", "Quiet", "Polite", "Tidy", "Sunny", "Cosy", "Humble", "Plain", "Gentle", "Busy", "Lucky", "Breezy",
  "Mellow", "Chipper", "Dapper", "Nimble", "Jolly", "Calm", "Rosy", "Snug", "Brisk", "Merry", "Witty", "Comfy"];
const NOUN = ["Otter", "Badger", "Pigeon", "Teapot", "Mole", "Ferret", "Hedgehog", "Muffin", "Robin", "Turnip", "Biscuit",
  "Walrus", "Pebble", "Beetle", "Sparrow", "Pickle", "Gnome", "Puffin", "Kettle", "Crumpet", "Owl", "Toad", "Bun", "Llama"];

export function genName(rand: () => number = Math.random): string {
  return `${ADJ[Math.floor(rand() * ADJ.length)]} ${NOUN[Math.floor(rand() * NOUN.length)]}`;
}
export function isGenName(n: string): boolean {
  const [a, b, c] = String(n).split(" ");
  return !c && ADJ.includes(a) && NOUN.includes(b);
}
